<template>
<ValidationObserver :ref="`rentalLocation${reference}`">
  <div class="form-group">
    <div class="form-group row mb-0">
      <div class="col-12">
        <address-details :address-entity="locationEntry.addressDetails" :mandatory="true" :is-read-only="isReadOnly"></address-details>
      </div>
    </div>

    <div class="form-group row mb-1">
      <div class="col-3">
        <label class="col-form-label text-left">Location Type<span class="text-danger">*</span></label>
        <ValidationProvider rules="required" :name="`locationEntry${reference}.locationType`" v-slot="{ errors }">
          <b-form-select class="custom-select custom-select-md" v-model="locationEntry.locationType" :disabled="isReadOnly">
            <option value="Head Office" :disabled="!allowHeadOfficeSelection">Head Office</option>
            <option value="Branch">Branch</option>
          </b-form-select>
          <span class="text-danger">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
      <div class="col-3">
        <label class="col-form-label text-left">Location/Branch Code</label>
        <ValidationProvider :rules="{ max: 30, regex: this.BRANCH_CODE_REGEX }" :name="`locationEntry${reference}.branchCode`" v-slot="{ errors }">
          <input class="form-control text-uppercase" v-model="locationEntry.branchCode" :disabled="isReadOnly"
                 maxlength="30" @input="formatBranchCode(locationEntry)"/>
          <span class="text-danger">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
    </div>

  </div>
  </ValidationObserver>
</template>

<style lang="scss">
</style>

<script>
import AddressDetails from "@/view/pages/wizard/components/AddressDetails.vue";

export default {
  name: "RentalLocation",

  components: {
    AddressDetails
  },

  props: {
    locationEntry: Object,
    reference: String,
    isReadOnly: Boolean,
    allowHeadOfficeSelection: {
      type: Boolean,
      default: true,
    },
    isUwMode: Boolean
  },

  data() {
    return {
      postalAddressOptions: [
        { text: "Yes", value: "samePostalAddress" },
        { text: "No", value: "differentPostalAddress" },
      ],
    };
  },

  methods : {
    formatBranchCode: function(location) {
      if(location.K_BranchCode) {
        location.K_BranchCode = location.K_BranchCode.toUpperCase().replace(/[^0-9a-zA-Z_-]/gi, '').trim();
      }
    }
  },

  computed: {
    BRANCH_CODE_REGEX: function () {
      return /^[a-zA-Z0-9-_]+$/;
    }
  }
};
</script>
